// extracted by mini-css-extract-plugin
module.exports = {"active":"JobsWithImpactFilterShortcut_active___Aj2K","button":"JobsWithImpactFilterShortcut_button__WYid3"};